const provenanceTags = new Set([
  "<citation_entries>",
  "</citation_entries>",
  "<rollout_ids>",
  "</rollout_ids>",
  "<oai-mem-citation>",
  "</oai-mem-citation>",
]);

const uuidOnly = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** Keep orchestration memory provenance out of browser-visible AI replies. */
export function visibleAiBody(input: string): string {
  let visible = input
    .replace(/<oai-mem-citation>[\s\S]*?<\/oai-mem-citation>/gi, "")
    .replace(/<oai-mem-citation>[\s\S]*$/gi, "");
  let removedProvenance = false;
  const lines: string[] = [];
  for (const line of visible.split(/\r?\n/)) {
    const trimmed = line.trim();
    if (provenanceTags.has(trimmed)) {
      removedProvenance = true;
      continue;
    }
    const positions = ["MEMORY.md:", "rollout_summaries/", "rollout_path="]
      .map((marker) => line.indexOf(marker))
      .filter((position) => position >= 0);
    if (positions.length > 0) {
      removedProvenance = true;
      const safePrefix = line.slice(0, Math.min(...positions)).trimEnd();
      if (safePrefix) lines.push(safePrefix);
      continue;
    }
    if (removedProvenance && uuidOnly.test(trimmed)) continue;
    lines.push(line);
  }
  while (lines.at(-1)?.trim() === "") lines.pop();
  return lines.join("\n");
}
